export const indianCities = [
  'Ahmedabad',
  'Amreli',
  'Aurangabad',
  'Banswara',
  'Burhanpur',
  'Chechat',
  'Denmal',
  'Dongaon',
  'Godhra',
  'Halwad',
  'Jamnagar',
  'Kalawad',
  'Kamlapur',
  'Kapadwanj',
  'Khambat',
  'Maisaheba',
  'Mandvi',
  'Morbi',
  'Mumbai',
  'Mundra',
  'Pisawada',
  'Pratapgarh',
  'Rampura',
  'Ranpur',
  'Selavi',
  'Shajapur',
  'Sidhpur',
  'Surat',
  'Taherabad',
  'Udaipur',
  'Ujjain',
  'Umreth',
  'Vadodara',
  'Wakaner',
];

export const indianStates = [
  'Gujarat',
  'Madhya Pradesh',
  'Maharashtra',
  'Rajasthan',
];
